const spacing = (factor) => `${0.25 * factor}rem`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  spacing,
};
